export default __webpack_public_path__ + "static/media/question-icon.3d58df61.svg";